 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDAD1 from '@/components/Backed/ad1'
 import OEBPSTITLE from '@/components/OEBPS/title'
 import OEBPSFM01 from '@/components/OEBPS/fm01'
 import OEBPSCONTENTS from '@/components/OEBPS/contents'
 import OEBPSAUTHORSNOTE from '@/components/OEBPS/authorsnote'
 import OEBPSPROLOGUE from '@/components/OEBPS/prologue'
 import OEBPSPART01 from '@/components/OEBPS/part01'
 import OEBPSCHAP01 from '@/components/OEBPS/chap01'
 import OEBPSCHAP02 from '@/components/OEBPS/chap02'
 import OEBPSCHAP03 from '@/components/OEBPS/chap03'
 import OEBPSPART02 from '@/components/OEBPS/part02'
 import OEBPSCHAP04 from '@/components/OEBPS/chap04'
 import OEBPSCHAP05 from '@/components/OEBPS/chap05'
 import OEBPSCHAP06 from '@/components/OEBPS/chap06'
 import OEBPSPART03 from '@/components/OEBPS/part03'
 import OEBPSCHAP07 from '@/components/OEBPS/chap07'
 import OEBPSCHAP08 from '@/components/OEBPS/chap08'
 import OEBPSCHAP09 from '@/components/OEBPS/chap09'
 import OEBPSCHAP10 from '@/components/OEBPS/chap10'
 import OEBPSPART04 from '@/components/OEBPS/part04'
 import OEBPSCHAP11 from '@/components/OEBPS/chap11'
 import OEBPSCHAP12 from '@/components/OEBPS/chap12'
 import OEBPSCHAP13 from '@/components/OEBPS/chap13'
 import OEBPSCHAP14 from '@/components/OEBPS/chap14'
 import OEBPSPART05 from '@/components/OEBPS/part05'
 import OEBPSCHAP15 from '@/components/OEBPS/chap15'
 import OEBPSCHAP16 from '@/components/OEBPS/chap16'
 import OEBPSCHAP17 from '@/components/OEBPS/chap17'
 import OEBPSCHAP18 from '@/components/OEBPS/chap18'
 import OEBPSCHAP19 from '@/components/OEBPS/chap19'
 import OEBPSPART06 from '@/components/OEBPS/part06'
 import OEBPSCHAP20 from '@/components/OEBPS/chap20'
 import OEBPSCHAP21 from '@/components/OEBPS/chap21'
 import OEBPSPART07 from '@/components/OEBPS/part07'
 import OEBPSCHAP22 from '@/components/OEBPS/chap22'
 import OEBPSCHAP23 from '@/components/OEBPS/chap23'
 import OEBPSEPILOGUE from '@/components/OEBPS/epilogue'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSBIBLIOGRAPHY from '@/components/OEBPS/bibliography'
 import OEBPSBACKGROUND from '@/components/OEBPS/background'
 import OEBPSCOPYRIGHT from '@/components/OEBPS/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/contents",
 			"name" : "OEBPS/contents",
 			"component" : OEBPSCONTENTS
 		},
 		{
 			"path" : "/OEBPS/authorsnote",
 			"name" : "OEBPS/authorsnote",
 			"component" : OEBPSAUTHORSNOTE
 		},
 		{
 			"path" : "/OEBPS/prologue",
 			"name" : "OEBPS/prologue",
 			"component" : OEBPSPROLOGUE
 		},
 		{
 			"path" : "/OEBPS/part01",
 			"name" : "OEBPS/part01",
 			"component" : OEBPSPART01
 		},
 		{
 			"path" : "/OEBPS/chap01",
 			"name" : "OEBPS/chap01",
 			"component" : OEBPSCHAP01
 		},
 		{
 			"path" : "/OEBPS/chap02",
 			"name" : "OEBPS/chap02",
 			"component" : OEBPSCHAP02
 		},
 		{
 			"path" : "/OEBPS/chap03",
 			"name" : "OEBPS/chap03",
 			"component" : OEBPSCHAP03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js